const INIT_ATTR = 'data-js-init';

function isInitialized(element, Class) {
  const value = element.getAttribute(INIT_ATTR);
  if (!value) return false;
  return value.split(' ').includes(Class.name);
}

function markInitialized(element, Class) {
  const value = element.getAttribute(INIT_ATTR);
  const names = value ? value.split(' ') : [];
  if (!names.includes(Class.name)) {
    names.push(Class.name);
    element.setAttribute(INIT_ATTR, names.join(' '));
  }
}

function factory(Class, selector, options = {}, root = document) {
  const instances = [];
  const elements = [...root.querySelectorAll(selector)];

  elements.forEach(element => {
    if (isInitialized(element, Class)) return;
    instances.push(new Class(element, options));
    markInitialized(element, Class);
  });

  return instances;
}

export default factory;
